import angular from 'angular';

const userIntegrationsServices = angular.module('applicationModule.userIntegrationsServices', []);

userIntegrationsServices.factory('Integrations', ['IntegrationsAPI', function (IntegrationsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return IntegrationsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data.message;
                });
        },
        getListQueue: function (appId, params) {
            return IntegrationsAPI.getListQueue(appId, params)
                .then(function (response) {
                    return response.data.message;
                });
        }
    };
}]);

userIntegrationsServices.service('IntegrationsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const INTEGRATION_URL = AppsoupAPI.API_URL + '/app/integrations/';

    this.getList = function (appId, params) {
        return $http.get(INTEGRATION_URL + 'index', {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.getListQueue = function (appId, params) {
        return $http.get(INTEGRATION_URL + 'indexQueue', {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
}]);

export default userIntegrationsServices;
